import React from "react";
import ReactPlayer from "react-player";
import { ElementType, ElementViewProps, VideoSettings } from "@/shared/types";
import { ElementPlaceholder } from "@/shared/Components/ElementPlaceholder/ElementPlaceholder";

export interface VideoViewProps extends ElementViewProps {}

const VideoView: React.FC<VideoViewProps> = ({ element }) => {
  const videoSettings = element?.settings as VideoSettings;

  const VideoReactPlayer =
    typeof ReactPlayer === "function"
      ? ReactPlayer
      : (ReactPlayer as any).default;

  return (
    <>
      {videoSettings?.url ? (
        <div
          data-test="VideoView"
          style={{
            display: "inline-block",
            width: "100%",
            height: "100%",
            borderRadius: `${videoSettings?.borderRadius}px`,
            overflow: "hidden",
          }}
        >
          <VideoReactPlayer
            key={`${videoSettings?.url}-${Date.now()}`} // this is to force the video to re-render after mounting
            light={!videoSettings?.autoplay} // the autoplay video doesn't work when the light prop is true that is why we used it only when the autoplay is false
            url={videoSettings?.url}
            controls={videoSettings?.controls}
            muted={videoSettings?.muted}
            loop={videoSettings?.loop}
            playing={videoSettings?.autoplay}
            width="100%"
            height="100%"
          />
        </div>
      ) : (
        <ElementPlaceholder elementType={ElementType.Video} />
      )}
    </>
  );
};

export { VideoView };
